import type { AdapterMeta } from "@repo/adapter-core";

export const ALLHOMES_ADAPTER_META: AdapterMeta = {
  slug: "allhomes-com-au",
  name: "allhomes.com.au",
  baseUrl: "https://www.allhomes.com.au",
  description:
    "ACT and Canberra focused property portal with strong coverage for ACT and surrounding NSW regions.",
  supportedStates: ["ACT", "NSW"],
  urlPattern: /allhomes\.com\.au\/[\w-]+-[a-z]{2,3}-\d{4}$/i,
  sourceType: "portal",
};
